import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'
// import { app } from '@/main'

const publicfacilityModule = {
  state: {
    // 社區公設列表
    publicfacilities: [],
    // 社區公設詳細資訊
    publicfacilityDetail: []
  },
  actions: {
    // 取得公設列表
    async GET_PUBLIC_FACILITIES({ commit }, payload) {
      // console.log('GET_PUBLIC_FACILITIES payload: ', payload)
      try {
        const communityId = payload.communityId
        const res = await baseFetch(
          API.getPublicFacilityByCommunityId.url(communityId),
          API.getPublicFacilityByCommunityId.method,
          payload.params
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          commit('SET_PUBLIC_FACILITIES', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取得公告詳細資訊
    async GET_PUBLIC_FACILITY_DETAIL({ commit }, payload) {
      // console.log('GET_PUBLIC_FACILITY_DETAIL payload: ', payload)
      try {
        const publicFacilityId = payload.publicFacilityId
        const res = await baseFetch(
          API.getPublicFacilityById.url(publicFacilityId),
          API.getPublicFacilityById.method
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          commit('SET_PUBLIC_FACILITY_DETAIL', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // // 新增公設
    async POST_PUBLIC_FACILITY({ dispatch }, payload) {
      // console.log('POST_PUBLIC_FACILITY payload: ', payload)
      try {
        const { params, goPublish } = payload
        const res = await baseFetch(
          API.postPublicFacility.url,
          API.postPublicFacility.method,
          params
        )
        // console.log('新增公設 res: ', res)
        if (!res.isError && res.data && !goPublish) return res
        if (!res.isError && res.data && goPublish) {
          const publicFacilityId = res.data.data.publicFacilityId
          const publishRes = await dispatch('PUBLISH_PUBLIC_FACILITY', {publicFacilityId})
          // console.log('publishRes: ', publishRes)
          return publishRes
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 編輯公設
    async PUT_PUBLIC_FACILITY({ dispatch }, payload) {
      // console.log('PUT_PUBLIC_FACILITY payload: ', payload)
      try {
        const { publicFacilityId, params, goPublish } = payload
        const res = await baseFetch(
          API.putPublicFacility.url(publicFacilityId),
          API.putPublicFacility.method,
          params
        )
        if (!res.isError && res.data && !goPublish) return res
        // 發佈動作
        if (!res.isError && res.data && goPublish) {
          const resPublicFacilityId = res.data.data.publicFacilityId
          const publishRes = await dispatch('PUBLISH_PUBLIC_FACILITY', {publicFacilityId: resPublicFacilityId})
          // console.log('publishRes: ', publishRes)
          return publishRes
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 刪除公設
    async DELETE_PUBLIC_FACILITY(_, payload) {
      // console.log('DELETE_PUBLIC_FACILITY payload: ', payload)
      try {
        const publicFacilityId = payload.publicFacilityId
        const res = await baseFetch(
          API.deletePublicFacility.url(publicFacilityId),
          API.deletePublicFacility.method
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 發佈公設
    async PUBLISH_PUBLIC_FACILITY(_, payload) {
      // console.log('PUBLISH_PUBLIC_FACILITY payload: ', payload)
      try {
        const publicFacilityId = payload.publicFacilityId
        const res = await baseFetch(
          API.publishPublicFacility.url(publicFacilityId),
          API.publishPublicFacility.method
        )
        // console.log('res: ', res)
        return res
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取消發佈公設
    async CANCEL_PUBLISH_PUBLIC_FACILITY(_, payload) {
      // console.log('CANCEL_PUBLISH_PUBLIC_FACILITY payload: ', payload)
      try {
        const publicFacilityId = payload.publicFacilityId
        const res = await baseFetch(
          API.cancelPublishPublicFacility.url(publicFacilityId),
          API.cancelPublishPublicFacility.method
        )
        // console.log('res: ', res)
        if (!res.isError && res.data) {
          return res
        }
      } catch (error) {
        console.error('error', error)
      }
    }
  },
  mutations: {
    // 儲存公設列表
    SET_PUBLIC_FACILITIES(state, payload) {
      state.publicfacilities = payload
    },
    // 儲存社區公設詳細資訊
    SET_PUBLIC_FACILITY_DETAIL(state, payload) {
      state.publicfacilityDetail = payload
    }
  },
  getters: {
    getPublicfacilities: (state) => state.publicfacilities,
    getPublicfacilityDetail: (state) => state.publicfacilityDetail
  },
  namespaced: true
}

export default publicfacilityModule
